window.showInfoBubble = (message) => {
  const bubble = document.createElement("div")
  bubble.classList.add("info-bubble")
  bubble.innerHTML = `
    <button class="info-bubble__close">
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <path d="M7.773 7L13.84.934a.547.547 0 10-.774-.774L7 6.227.934.16A.547.547 0 10.16.934L6.227 7 .16 13.066a.547.547 0 10.774.774L7 7.773l6.066 6.067a.545.545 0 00.774 0 .547.547 0 000-.774z" fill="#000"></path>
      </svg>
    </button>
    ${message}
  `
  document.body.appendChild(bubble)

  bubble.querySelector("button").addEventListener("click", () => {
    bubble.remove()
  })

  setTimeout(() => {
    bubble.remove()
  }, 3000)
}
